export default __webpack_public_path__ + "static/media/introLanding.6ef2badb.jpg";